











































































import _ from 'lodash';
import Vue from 'vue';
import Component from 'vue-class-component';
import {notify, Colors} from '@/modules/core/notification';
import {State} from 'vuex-class';
import JWTToken, {ActiveUser, User} from '@/modules/auth/types';
import {VForm} from 'vuetify/lib';
import ActiveUsers from '@/modules/auth/components/ActiveUsers.vue';
import {Watch} from 'vue-property-decorator';

/**
 * Componente de inicio de sesión
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {
        ActiveUsers,
        'v-form': VForm,
    },
})
export default class LoginComponent extends Vue {

    public $refs: Vue['$refs'] & {
        password: {
            focus (): void,
        },
    }

    /**
     * Cambiado usuario
     *
     * Indica si la aplicación se encuentra transicionado de un usuario a otro
     */
    @State(state => state.auth.changingActiveUser)
    public changingUser: boolean

    /**
     * Lista con todos los usuarios guardados en la aplicación
     */
    @State(state => state.auth.activeUsers)
    public activeUsers: ActiveUser[]

    /**
     * Usuario actual de la aplicación si existe alguna
     *
     * @var { User }
     */
    @State(state => state.auth.user)
    public currentUser: User | null

    public user = '';
    public password = '';
    public inProcess = false;
    public failed = false;
    public errorMessage = '';
    public formIsValid = true;

    @State(state => state.auth.token)
    public token: JWTToken | null;


    public step = 0
    public loadingActiveUser = false

    public onRemovedUser () {
        // tslint:disable-next-line:no-unused-expression
        (!this.activeUsers.length) && (this.step = 0)
    }

    public async selectActiveUser (user: ActiveUser) {
        // El usuario seleccionado es el mismo que el usuario actual, se vuelve al dashboard
        if (this.currentUser && this.currentUser.id === user.id) {
            await this.$router.push({name: 'dashboard'})

            this.$store.commit('showToolbar')
            this.$store.commit('showSidenav')

            return
        }

        // El usuario seleccionado no tiene token, debe autenticarse de nuevo
        if (!user.token) {
            this.step = 0
            this.user = user.email
            // Espera al siguiente ciclo del bucle de cambios para otorgar el foco
            // al input de la contraseña
            await this.$nextTick()
            this.$refs.password.focus()

            return
        }

        this.loadingActiveUser = true
        await this.$store.dispatch('auth/changeActiveUser', user)
        await this.$router.push({name: 'dashboard'})

        this.$store.commit('showToolbar')
        this.$store.commit('showSidenav')

        this.loadingActiveUser = false
    }

    @Watch('step')
    public onStepChange () {
        this.failed = false
    }


    public async created () {
        // Ya existe un token de autorización, la aplicación redirige al usuario
        // al la pantalla prinicipal
        if (this.token && !this.changingUser) {
            await this.$router.push({name: 'dashboard'});

            return
        }

        if (this.$store.state.auth.activeUsers.length) {
            this.step = 1
        }

        const user = this.$store.state.auth.activeUserToBeAuthenticated
        if (user.id) {
            this.user = user.email
            this.step = 0

            await this.$nextTick()
            this.$refs.password.focus()
        }

        this.$store.commit('hideSidenav');
        this.$store.commit('hideToolbar');
    }

    /**
     * Referencia del formulario
     */
    private get form (): { validate: () => boolean } {
        // any es necesario porque typescript no es capaz de detectar que $refs define
        // la propiedad {form}
        return this.$refs.form as any;
    }


    /**
     * Reglas de validación para los campos del formulario
     *
     * @type { Object }
     */
    public validationRules = {
        email: [
            (v: string) => !!v || 'El correo electrónico es obligatorio',
            // tslint:disable-next-line:max-line-length
            (v: string) => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'El correo electronico debe ser válido',
        ],
        password: [
            // (v: string) => v.length >= 3 || "La contraseña debe tener al menos 6 caractéres",
        ],
    };

    /**
     * Inicio de sesión
     */
    public async login () {
        if (!this.form.validate()) {
            return;
        }

        this.inProcess = true;
        this.failed = false;

        await this.$store.dispatch('auth/login', {
            user: this.user,
            password: this.password,
        });

        await this.$router.push({name: 'dashboard'})
        notify('Has iniciado sesión correctamente', Colors.Success, {notShowInCenter: true})

        this.$store.commit('showSidenav')
        this.$store.commit('showToolbar')
    }

    public errorCaptured (error: Error) {
        this.failed = true;
        this.errorMessage = _.get(error, 'response.data.message', error.message);
        this.inProcess = false;
    }
}
